import { render, staticRenderFns } from "./AgencyLabel.vue?vue&type=template&id=bd199cd6&scoped=true"
import script from "./AgencyLabel.vue?vue&type=script&lang=js"
export * from "./AgencyLabel.vue?vue&type=script&lang=js"
import style0 from "./AgencyLabel.vue?vue&type=style&index=0&id=bd199cd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd199cd6",
  null
  
)

export default component.exports